import Carousel from './projects/Carousel';

export default function Projects() {
  return (
    <section
      id="projects"
      className="portfolio__projects portfolio__elem"
    >
      <h2>Proyectos</h2>
      <Carousel />
    </section>
  );
}
